import React, { useEffect, useState, useRef, useCallback } from "react"
import Components from "../index"
import { blokType } from "../../types"
import IconV2 from "../icon-v2"

import {
    StyledCarouselWrapper,
    StyledCarousel,
    StyledSlides,
    StyledButton,
} from "./partials/StyledCarousel"

export interface CarouselProps {
    slides_per_view_mobile: number
    slides_per_view_tablet: number
    slides_per_view_desktop: number
    slides_per_view_wide: number
    slides?: blokType[]
    children?: React.ReactNode
}

export const CarouselCmp: React.FC<CarouselProps> = ({
    slides_per_view_mobile,
    slides_per_view_tablet,
    slides_per_view_desktop,
    slides_per_view_wide,
    slides,
    children,
}) => {
    const ref = useRef<HTMLDivElement>()
    const [sliderWidth, setSliderWidth] = React.useState("")
    const [showLeft, setShowLeft] = React.useState(false)
    const [showRight, setShowRight] = React.useState(true)

    const width = useCallback((node) => {
        if (node !== null) {
            setSliderWidth(node.getBoundingClientRect().width)
            if (typeof window !== "undefined") {
                window.addEventListener("resize", () => {
                    setSliderWidth(node.getBoundingClientRect().width)
                })
            }
        }
        parseInt(sliderWidth)
    }, [])

    const scroll = (scrollOffset) => {
        ref.current.scrollLeft += scrollOffset
    }

    const listenScrollEvent = () => {
        if (ref.current.scrollLeft === 0) {
            setShowLeft(false)
        }
        else {
            setShowLeft(true)
        }
        if (Math.round(ref.current?.scrollLeft + ref.current?.offsetWidth) === ref.current?.scrollWidth) {
            setShowRight(false)
        }
        else {
            setShowRight(true)
        }
    }

    useEffect(() => {
        ref.current?.addEventListener('scroll', listenScrollEvent);

    }, [ref])




    return (
        <StyledCarouselWrapper>
            <StyledCarousel ref={width}>
                <StyledSlides
                    ref={ref}
                    slides_per_view_mobile={slides_per_view_mobile}
                    slides_per_view_tablet={slides_per_view_tablet}
                    slides_per_view_desktop={slides_per_view_desktop}
                    slides_per_view_wide={slides_per_view_wide}
                    slides_count={slides && slides[0].quantity || slides && slides?.length}
                >

                    {slides && (
                        slides.map((content) => (
                            React.createElement(Components(content.component), {
                                key: content._uid,
                                blok: content,
                            })
                        ))
                    )}

                </StyledSlides>
                <StyledButton
                    onClick={() => scroll(-sliderWidth)}
                    slides_per_view_wide={slides_per_view_wide}
                    slides_per_view_desktop={slides_per_view_desktop}
                    slides_per_view_tablet={slides_per_view_tablet}
                    slides_per_view_mobile={slides_per_view_mobile}
                    show_button={showLeft}
                >
                    <IconV2 icon="arrow-left" />
                </StyledButton>
                <StyledButton onClick={() => scroll(sliderWidth)} show_button={showRight}>
                    <IconV2 icon="arrow-right" />
                </StyledButton>
            </StyledCarousel>
        </StyledCarouselWrapper>
    )
}
